<div>
  <div class="mt-4">
    @if (checkPermission('pesquisar-paginado')) {
      <!--      <form-search [search]="inputSearch" (responseSearch)="search($event)" />-->
      <form-client-search
        [search]="inputSearch"
        [listSearch]="listSearch"
        (responseSearch)="search($event)"
      />
    }
    <div>
      @if (!loading) {
        <div>
          <table-list-simple
            [dataSource]="itemsList"
            [columns]="columns"
            [listClient]="true"
            (selectItem)="editItem($event)"
            (deleteItem)="deleteItem($event)"
            (convertSubClientItem)="convertClientItem($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
